import { render, staticRenderFns } from "./SendStatusUpdate.vue?vue&type=template&id=774e54b0"
import script from "./SendStatusUpdate.vue?vue&type=script&lang=js"
export * from "./SendStatusUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports